import React from 'react';
import { ContentSection } from '../ui/ContentSection';
export function FAQ() {
  return <ContentSection background="gray" data-id="element-17">
      <div className="text-center mb-16" data-id="element-18">
        <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-19">
          OBJECIONES
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A]" data-id="element-20">
          Preguntas comunes
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-8" data-id="element-21">
        {[{
        q: 'No tengo tiempo para leer',
        a: 'Precisamente por eso lo necesitas. Tu problema no es tiempo, es foco.'
      }, {
        q: 'Ya soy disciplinada',
        a: 'Perfecto. Este libro no te quita disciplina. La dirige.'
      }, {
        q: '¿Y si no cambia nada?',
        a: 'La claridad siempre cambia algo. Y suele cambiarlo todo.'
      }].map((item, i) => <div key={i} className="bg-white p-8 rounded-xl shadow-sm" data-id="element-22">
            <h3 className="text-xl font-bold text-[#1A1A1A] mb-3" data-id="element-23">
              "{item.q}"
            </h3>
            <div className="flex items-start gap-3" data-id="element-24">
              <span className="text-amber-500 font-bold text-xl" data-id="element-25">→</span>
              <p className="text-gray-600 text-lg" data-id="element-26">{item.a}</p>
            </div>
          </div>)}
      </div>
    </ContentSection>;
}